var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('v-row',[_c('v-col',[_c('h3',[_vm._v("Eixos para análise de processos de pagamento")]),_c('p',[_vm._v("Esta autorização é independente das permissões de municípios e eixos abaixo.")]),_c('app-axis-by-project-combobox',{attrs:{"filter":_vm.selection,"name":"Eixos permitidos para processos de pagamento"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }